<template>
  <div class="home-body">
    <div class="container xs-pt-30 xs-pb-50">
      <h1 class="serif">Terms and Conditions</h1>
      <br />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut non condimentum est, porttitor semper lectus. Cras tincidunt pretium dapibus. Aliquam erat volutpat. Fusce varius augue lacus, et condimentum lacus congue in. Nam aliquam nisi ut nisl pharetra, ac feugiat eros tincidunt. Integer non scelerisque neque, a semper arcu. Etiam fermentum placerat arcu. Donec consectetur, purus quis ullamcorper tincidunt, orci erat placerat magna, ut molestie leo leo eu eros. Morbi ut tortor a ex maximus venenatis. Integer varius, arcu id ultricies malesuada, metus sem lobortis tortor, quis cursus tortor neque vel orci. Fusce feugiat ante blandit est hendrerit finibus. Nullam ultrices sit amet neque sit amet mattis. Nam lobortis nulla vel diam consectetur volutpat. Nam porttitor mattis diam, nec sodales nunc pulvinar non. Vivamus eget justo nisl. Nulla finibus odio odio, eu suscipit magna semper ac.
      </p><p>
        Maecenas pulvinar nisi sit amet ligula congue, imperdiet varius diam posuere. Vestibulum ac est vestibulum, ultrices erat et, accumsan purus. Suspendisse potenti. Phasellus condimentum lorem a quam tincidunt mattis. In pulvinar erat at arcu molestie, vitae mollis enim dapibus. Nulla arcu arcu, aliquet ut urna sit amet, tristique tristique erat. Cras eu metus ligula. Quisque elit ipsum, ornare eget quam sit amet, commodo aliquam diam. Cras feugiat lorem a sapien tincidunt, a molestie elit pretium. Curabitur molestie tellus eu consequat pulvinar.
      </p><p>
        Nunc gravida nulla arcu. Praesent id posuere felis. Mauris risus sapien, aliquet ut mollis sit amet, sollicitudin at velit. Etiam eget porta justo. Donec eget interdum sapien. Proin id diam elit. Sed aliquet lacus velit, a ultrices metus sagittis placerat. Pellentesque eu arcu est. Integer et ornare erat. Curabitur porta quam sed diam fermentum, ut condimentum tellus pretium. Phasellus in molestie nulla, sed pretium tortor.
      </p>
    </div>
  </div>

</template>


<script>
import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'


export default {
  components: {
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body { background: #FFFFFF; }
</style>



// WEBPACK FOOTER //
// TermsConditionsPage.vue?0b460e95